<template>
    <router-link
      v-if='category'
      tag='div'
      class='cur_p un_menuitem mar_b_05'
      activeClass='active'
      :to='"/category/"+category.id'>
      <p>
        {{ category.name }}
        <MiniLoader
          v-if='loading.items && loading.items === String(this.category.id)'
          class='el-loader'/>
      </p>
    </router-link>
</template>
<script>
import { mapState } from 'vuex'
import MiniLoader from '$shared/loaders/MiniLoader.vue'
export default {
  props: {
    category: {
      type: Object,
      required: true,
      default: function () {
        return {}
      }
    }
  },
  computed: {
    ...mapState('system', ['loading', 'currentCategory'])
  },
  components: {
    MiniLoader
  }
}
</script>
<style lang='scss' scoped>
.un_menuitem{
  position: relative;
  padding:0rem 2.5rem;
  border-radius:0.17rem;
  @include t_btn_hover;
  .el-loader{
    position: absolute;
    right:0;
    top:50%;
    transform:translateY(-50%);
  }
  &:before{
    content: '';
    display: block;
    position: absolute;
    left:0;
    top:0;
    height:100%;
    width:0.25rem;
    background-color: #ff6f4c;
    transform: scale(0, 1);
    transition: all 0.2s ease-in-out;
  }
  p{
    @include font-size(1.2);
    width: 13rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #1e1e6b;
    padding: 0.85rem 0rem;
    @include type_bold;

    &.active{
      background-color:rgba(255, 254, 242, 0.11);
      color: #ffffff;
    }

  }
  &:hover, &.active{
    p{
      color: rgb(0, 0, 255);
    }
  }
  &.active{
    background-color:rgba(255, 255, 255, 0.5);
    &:before{ transform: scale(1, 1); }
  }
}
</style>



// WEBPACK FOOTER //
// uncommon-client/components/gold-admin/Category.vue